import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Hero from './Hero/Hero';
import Detail from './Detail/Detail';
import NotFound from '../NotFound/NotFound';

const NewsDetails = props => {
    const { news } = props;
    const slug = props.match.params.cta;
    let data = {};

    if (slug && news) {
        data = news.find(current => current.slug === `/${slug}`);
    }

    if (!data) return <NotFound />;
    const objData = {
        preTitle: 'Press & Insights',
        title: data.title,
        path: data.images[0] ? `${process.env.RAZZLE_ASSET_URL}${data.images[0]}` : '',
    };

    return (
        <div className="news-view">
            <Hero data={objData} />
            <Detail serverURL={props.serverURL} data={data} />
        </div>
    );
};

NewsDetails.propTypes = {
    news: PropTypes.array,
    match: PropTypes.object,
    serverURL: PropTypes.string,
};

export default connect(
    ({ content }) => ({
        news: content.news,
    }),
    null
)(NewsDetails);
